import { useState } from "react";
import { useAuth } from "@clerk/react";
import { Tag } from "lucide-react";
import { apiFetch } from "@/lib/reels";

// One-tap category change: a native picker over a small pill on the tile.
export const MovePill = ({ video, groups, i, onMoved }) => {
  const { getToken } = useAuth();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  const move = async (category) => {
    if (!category || category === video.category) return;
    setBusy(true);
    setFailed(false);
    try {
      await apiFetch(`/library/videos/${video.id}`, { method: "PATCH", token: await getToken(), body: JSON.stringify({ category }) });
      onMoved(video.id, category);
    } catch (e) {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="absolute bottom-1.5 left-1.5 flex items-center gap-1 rounded-full bg-white/95 px-2 py-1 text-[11px] font-bold text-[#2a1e17] shadow" data-testid={`move-pill-${i}`}>
      {busy ? <span className="rs-spinner !h-3 !w-3" /> : <Tag size={11} className="text-[#d7352b]" />}
      {failed ? <span className="text-[#c62d22]" data-testid={`move-error-${i}`}>Retry</span> : "Move"}
      <select className="absolute inset-0 cursor-pointer opacity-0" value={video.category || ""} disabled={busy}
        onChange={(e) => move(e.target.value)} aria-label="Move to category" data-testid={`move-select-${i}`}>
        <option value="" disabled>Move to…</option>
        {groups.groups.map((g) => (
          <optgroup key={g.id} label={g.name}>
            {g.categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </optgroup>
        ))}
        <option value={groups.other.id}>{groups.other.name}</option>
      </select>
    </label>
  );
};
